import React, { useEffect } from "react";
import "./App.css";
import AOS from "aos";
import "aos/dist/aos.css";
import Router from "./Router";
import { HelmetProvider } from "react-helmet-async";
import MaintenanceMode from "./components/MaintenanceMode";

// Baked in at build time. Set REACT_APP_MAINTENANCE=true to take the site down.
const MAINTENANCE = process.env.REACT_APP_MAINTENANCE === "true";

const App = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  // type: "" (neutral), "error" (red), or "success" (green)
  const showmessage = async (message, type = "") => {
    try {
      var x = document.getElementById("snackbar");
      x.className = type ? `show ${type}` : "show";
      x.innerText = message;
      setTimeout(function () {
        x.className = "";
      }, 3000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <HelmetProvider>
      {MAINTENANCE ? <MaintenanceMode /> : <Router />}
    </HelmetProvider>
  );
};

export default App;
